import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function MagicCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [errorMsg, setErrorMsg] = useState("");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setErrorMsg("Enlace inválido");
      return;
    }
    api
      .get(`/auth/staff/magic/verify?token=${encodeURIComponent(token)}`)
      .then(({ data }) => {
        localStorage.setItem("agenda_token", data.token);
        setStatus("ok");
        setTimeout(() => { window.location.href = "/app"; }, 600);
      })
      .catch((err) => {
        setStatus("error");
        setErrorMsg(err?.response?.data?.detail || "Enlace inválido o caducado");
      });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4EFE4] px-6">
      <div className="max-w-md w-full bg-white border border-[#E8DFD2] rounded-2xl p-8 text-center" data-testid="magic-callback-box">
        {status === "verifying" && (
          <>
            <div className="font-display text-2xl text-[#3A2418] mb-2">Verificando tu enlace…</div>
            <p className="text-sm text-[#6F5A4C]">Un momento, casi entras.</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="font-display text-2xl text-[#3A2418] mb-2">¡Bienvenida!</div>
            <p className="text-sm text-[#6F5A4C]">Te llevamos a tu panel…</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="font-display text-2xl text-[#3A2418] mb-2">No pudimos entrarte</div>
            <p className="text-sm text-[#6F5A4C] mb-4">{errorMsg}</p>
            <button
              onClick={() => navigate("/login")}
              className="text-[#B5704A] underline text-sm"
              data-testid="magic-back-login"
            >
              Volver al inicio de sesión
            </button>
          </>
        )}
      </div>
    </div>
  );
}
